/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    ul: "ul",
    li: "li",
    pre: "pre",
    blockquote: "blockquote",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Refs | v4"
    }), "\n", _jsxs(_components.p, {
      children: ["Passing a ", _jsx(_components.code, {
        children: "ref"
      }), " prop to a styled component will give you one of two things depending on the styled target:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["the underlying DOM node (if targeting a basic element, e.g. ", _jsx(_components.code, {
          children: "styled.div"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["a React component instance (if targeting a custom component e.g. extended from ", _jsx(_components.code, {
          children: "React.Component"
        }), ")"]
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "const Input = styled.input`\n  padding: 0.5em;\n  margin: 0.5em;\n  color: #BF4F74;\n  background: papayawhip;\n  border: none;\n  border-radius: 3px;\n`;\n\nclass Form extends React.Component {\n  constructor(props) {\n    super(props);\n    this.inputRef = React.createRef();\n  }\n\n  render() {\n    return (\n      <Input\n        ref={this.inputRef}\n        placeholder=\"Hover to focus!\"\n        onMouseEnter={() => {\n          this.inputRef.current.focus()\n        }}\n      />\n    );\n  }\n}\n\nrender(\n  <Form />\n);\n"
      })
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["Using an older version of styled-components (below 4.0.0) or of React? Use the ", _jsxs(_components.a, {
          href: "/docs/api#innerref-prop",
          children: [_jsx(_components.code, {
            children: "innerRef"
          }), " prop"]
        }), " instead."]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
